import { Close, FilterList, Search } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";

import Helpers from "../../../commons/helpers";
import useStrings from "../../../hooks/useStrings";
import Box from "../../Box";
import Button from "../../Button";
import TextField from "../../TextField";
import Typography from "../../Typography";

import { DataTableProps } from "..";

export const TableSearch = <T,>({
    isLocal,
    leftElement,
    searchText,
    placeholderSearch,
    onSearch,
    onSearchChange,
    onFilter,
    allowCheckbox,
    dataSelected,
    handleOnChangeSelected,
    actionTypeSelectBox,
    onSubmitActionCheckedBox,
    setGlobalFilter,
    search,
    setFilter,
    setSearch,
}: Pick<
    DataTableProps<T>,
    | "isLocal"
    | "leftElement"
    | "searchText"
    | "placeholderSearch"
    | "onSearch"
    | "onSearchChange"
    | "onFilter"
    | "allowCheckbox"
    | "dataSelected"
    | "handleOnChangeSelected"
    | "actionTypeSelectBox"
    | "onSubmitActionCheckedBox"
> & {
    setGlobalFilter: (filterValue: any) => void;
    setFilter: React.Dispatch<React.SetStateAction<boolean>>;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    search: string;
}): JSX.Element => {
    const strings = useStrings();

    const renderBtnActionTypeSelectBox = () => {
        const _listActionTypeSelectBox: any[] = [...(actionTypeSelectBox || [])].filter((item) => item !== false) || [];

        return (
            <Grid item xs={12} md={12} justifyItems="center">
                <Box display="flex" alignItems="center" pt={2}>
                    <Typography variant="button" color="secondary" fontWeight="regular">
                        {strings.format(strings.Common.SELECTED_RECORD, [...(dataSelected || [])].length).toString()}
                    </Typography>
                    <Button
                        color="secondary"
                        variant="gradient"
                        sx={{ marginLeft: "5px", minHeight: 30, px: 1, py: 0 }}
                        onClick={() => {
                            Helpers.isFunction(handleOnChangeSelected) && handleOnChangeSelected([]);
                        }}
                    >
                        {strings.Common.CANCEL_SELECT}
                    </Button>
                    {_listActionTypeSelectBox.length > 0 &&
                        _listActionTypeSelectBox.map((item) => {
                            return (
                                <Button
                                    key={"btn_c_" + item.actionType}
                                    color={item.color}
                                    sx={{
                                        py: 0,
                                        px: 1,
                                        minHeight: 30,
                                        marginLeft: "5px",
                                    }}
                                    onClick={() => {
                                        if (Helpers.isFunction(onSubmitActionCheckedBox)) {
                                            onSubmitActionCheckedBox([...(dataSelected || [])], item.actionType);
                                        }
                                        Helpers.isFunction(handleOnChangeSelected) && handleOnChangeSelected([]);
                                    }}
                                >
                                    {item.actionName}
                                </Button>
                            );
                        })}
                </Box>
            </Grid>
        );
    };

    return (
        <Box alignItems="center" mb={1}>
            <Grid container alignItems="end">
                <Grid item xs={12} md={6} justifyItems="center">
                    {leftElement}
                </Grid>
                {/* Search Text and Felter*/}
                <Grid item xs={12} md={6} justifyItems="center">
                    <Box display="flex" justifyContent="end" alignItems="center">
                        {/* Search Text */}
                        {(Helpers.isFunction(onSearch) || Helpers.isFunction(onSearchChange)) && (
                            <Box width="15rem" ml="auto" mr={1} p={0}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    key={search}
                                    maxLength={255}
                                    defaultValue={search || ""}
                                    placeholder={placeholderSearch ? placeholderSearch : `${strings.Common.SEARCH}...`}
                                    onBlur={(e: any) => {
                                        setSearch(e.target.value);
                                        Helpers.isFunction(onSearchChange) && onSearchChange(e.target.value);
                                    }}
                                    onKeyPress={(e: any) => {
                                        if (e.key === "Enter") {
                                            setSearch(e.target.value);
                                            Helpers.isFunction(onSearchChange) && onSearchChange(e.target.value);
                                            if (isLocal) {
                                                setGlobalFilter(e.target.value);
                                            } else {
                                                Helpers.isFunction(onSearch) && onSearch(e.target.value);
                                            }
                                        }
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <IconButton
                                                color="info"
                                                onClick={() => {
                                                    isLocal ? setGlobalFilter(search) : onSearch(search);
                                                }}
                                            >
                                                <Search />
                                            </IconButton>
                                        ),
                                        endAdornment: search && (
                                            <IconButton
                                                color="secondary"
                                                onClick={() => {
                                                    setSearch(undefined);
                                                    Helpers.isFunction(onSearchChange) && onSearchChange("");
                                                    if (isLocal) {
                                                        setGlobalFilter("");
                                                    } else {
                                                        Helpers.isFunction(onSearch) && onSearch("");
                                                    }
                                                }}
                                            >
                                                <Close />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </Box>
                        )}
                        {/* Icon Filter */}
                        {Helpers.isFunction(onFilter) && (
                            <IconButton onClick={() => setFilter((prev) => !prev)}>
                                <FilterList />
                            </IconButton>
                        )}
                    </Box>
                </Grid>
                {/*List Button Action By Selected */}
                {allowCheckbox && [...(dataSelected || [])].length > 0 && renderBtnActionTypeSelectBox()}
            </Grid>
        </Box>
    );
};

export default TableSearch;
